import * as React from 'react';
import ReactDOM from 'react-dom';
import './Style.css';
//Page Sections
import NavBar from "./NavBar";

export default function App() {

  return (
    <div className="App">
      <NavBar />
    </div>
  );
}
const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
